import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ModalRef } from "@shared/components";
import { Book } from "@modules/books/types";

export const useAudioFileListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  audioFileModalRef: RefObject<ModalRef>,
  books?: Book[]
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "id",
        headerName: translate("v1/audiobook_admin.fields.id"),
        width: 80,
      },
      {
        field: "book",
        headerName: translate("v1/audiobook_admin.fields.book"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/books/edit/${value}`}
            value={books?.find(book => Number(book.id) === Number(value))?.title}
          />
        ),
      },
      {
        field: "position",
        headerName: translate("v1/audiobook_admin.fields.position"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            align="center"
          />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => audioFileModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, audioFileModalRef, books]
  );
};
